export interface TitleBrandingProps {
  gray_label?: boolean
  white_label?: boolean
}

// Growbotik-owned surfaces (agency console, admin, vendor, signup) leave
// `white_label` unset, so we append the app name by default. Only genuinely
// white-labeled surfaces send `white_label: true` to opt out of the suffix.
export function shouldAppendAppName(props: TitleBrandingProps) {
  return props.white_label !== true && props.gray_label !== true
}

export function formatPageTitle(
  title: string,
  props: TitleBrandingProps,
  appName: string,
) {
  return shouldAppendAppName(props) ? `${title} - ${appName}` : title
}
